<template>
    <div v-if="coloredService.loaded">
      <v-chip
        :color="coloredService.backgroundColor"
        class="chip--select-multi v-chip--small">
        <v-tooltip bottom style="z-index: 1000">
                  <span slot="activator" v-bind:style="{'color': coloredService.fontColor}">
                    {{ coloredService.code }}
                  </span>
          {{ coloredService.title }}
          <dev-mode>
            {{serviceId}}
          </dev-mode>
        </v-tooltip>
      </v-chip>
    </div>
    <div v-else>{{serviceId}}</div>
</template>

<script>
    import _ from 'lodash'
    import {mapState} from 'vuex'
    import {getContrastFontColorByBackground} from '../../../helpers/styles'
    import DevMode from "../DevMode";

    export default {
        name: 'service-as-badge',
        components: {
            DevMode
        },
        props: {
            serviceId: {
                type: String,
                required: true
            },
        },
        data() {
            return {}
        },
        computed: {
            ...mapState({
                availableServiceGroups: 'availableServiceGroups',
                availableServices: 'availableServices',
                devMode: 'devMode'
            }),
            coloredService() {
                const serviceId = this.serviceId;
                const service = _.find(this.availableServices, it => it.id === serviceId);
                const availableServiceGroupsById = _.keyBy(this.availableServiceGroups, 'id');

                if (!service) {
                    return {
                        id: this.serviceId,
                        loaded: false
                    };
                }

                const backgroundColor = _.get(availableServiceGroupsById, [service.groupId, 'colorScheme'], void 0);

                return {
                    id: this.serviceId,
                    loaded: true,
                    code: service.code,
                    title: service.title,
                    backgroundColor: backgroundColor,
                    fontColor: getContrastFontColorByBackground(backgroundColor)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/mcc/ServiceAsBadge.vue